import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    endDate,
    startDate,
    firstTime,
    supplementaryForThe,
    taxPayerId,
    taxPayerName,
    taxAgencyId,
    taxAgencyName,
    taxAgentContract,
    taxAgentContractDate,
    contractorContract,
    contractorContractDate,

    certificate,
    fullName,
    signer,
    timeSign,
  },
} = checkout;

const validation = Yup.object().shape({
  [startDate.name]: Yup.number().required(startDate.errorMsg),
  [endDate.name]: Yup.number().required(endDate.errorMsg),
  [taxAgentContractDate.name]: Yup.number().required(taxAgentContractDate.errorMsg),
  [taxAgentContract.name]: Yup.string().required(taxAgentContract.errorMsg),
  [contractorContractDate.name]: Yup.number().required(contractorContractDate.errorMsg),
  [contractorContract.name]: Yup.string().required(contractorContract.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [supplementaryForThe.name]: Yup.string()
  .matches(/^\d+$/, supplementaryForThe.invalidMsg)
  .required(supplementaryForThe.errorMsg),
  [taxPayerId.name]: Yup.string()
  .matches(/^\d{10}(?:-\d{3})?$/, taxPayerId.invalidMsg)
  .required(taxPayerId.errorMsg),
  [taxPayerName.name]: Yup.string().required(taxPayerName.errorMsg),
  [taxAgencyName.name]: Yup.string().optional(),
  [taxAgencyId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgencyId.invalidMsg)
    .required(taxAgencyId.errorMsg),

  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
});

export default validation;
